export var PREPROD_PREVIEW_EVENTS;

(function (PREPROD_PREVIEW_EVENTS) {
  PREPROD_PREVIEW_EVENTS["LITE_CREATE_BOARD"] = "LITE_CREATE_BOARD";
  PREPROD_PREVIEW_EVENTS["LITE_USE_FULLSCREEN"] = "LITE_USE_FULLSCREEN";
  PREPROD_PREVIEW_EVENTS["PREPROD_READY"] = "PREPROD_READY";
  PREPROD_PREVIEW_EVENTS["LITE_FIT_CONTENT"] = "LITE_FIT_CONTENT";
  PREPROD_PREVIEW_EVENTS["LITE_FULLSCREEN_STATUS"] = "LITE_FULLSCREEN_STATUS";
  PREPROD_PREVIEW_EVENTS["LITE_BOARD_CREATED"] = "LITE_BOARD_CREATED";
})(PREPROD_PREVIEW_EVENTS || (PREPROD_PREVIEW_EVENTS = {}));

export var PREPROD_PREVIEW_ACTIONS;

(function (PREPROD_PREVIEW_ACTIONS) {
  PREPROD_PREVIEW_ACTIONS["SET_IFRAME_READY"] = "SET_IFRAME_READY";
  PREPROD_PREVIEW_ACTIONS["SET_IS_IFRAME_VISIBLE"] = "SET_IS_IFRAME_VISIBLE";
  PREPROD_PREVIEW_ACTIONS["SET_BOARD_STATUS"] = "SET_BOARD_STATUS";
  PREPROD_PREVIEW_ACTIONS["SET_BOARD_CONTAINER_DISPLAY_MODE"] = "SET_BOARD_CONTAINER_DISPLAY_MODE";
  PREPROD_PREVIEW_ACTIONS["SET_IFRAME_CONFIG"] = "SET_IFRAME_CONFIG";
  PREPROD_PREVIEW_ACTIONS["SET_IFRAME_REF"] = "SET_IFRAME_REF";
  PREPROD_PREVIEW_ACTIONS["TOGGLE_MODAL"] = "TOGGLE_MODAL";
  PREPROD_PREVIEW_ACTIONS["SET_EDITABLE_TEMPLATES_CONFIG"] = "SET_EDITABLE_TEMPLATES_CONFIG";
  PREPROD_PREVIEW_ACTIONS["SET_IS_BOARD_ACTIVE"] = "SET_IS_BOARD_ACTIVE";
})(PREPROD_PREVIEW_ACTIONS || (PREPROD_PREVIEW_ACTIONS = {}));